import component from "./Partners"

export default { 
    component,
    urlHash: "#partners",
    mobile: component,
}